// Mirror of qwire-import commercial-import/types.ts + parse-commercial-grid.ts — keep in sync.
export const MIN_ROWS = 10;
export const MAX_ROWS = 100;
export const MAX_FILE_BYTES = 3 * 1024 * 1024;

export const REQUIRED_COLUMNS = [
  'Track Title',
  'Performer',
  'Master Licensors',
  'Sync Licensors',
  'Writers',
  'Publishers',
] as const;

export type FileErrorCode =
  | 'NOT_EXCEL_FILE'
  | 'FILE_TOO_LARGE'
  | 'FILE_STRUCTURE_INVALID'
  | 'MISSING_REQUIRED_INFO'
  | 'TOO_FEW_ROWS'
  | 'TOO_MANY_ROWS'
  | 'IMPORT_START_FAILED';

export type FileError = {
  code: FileErrorCode;
  params?: Record<string, unknown>;
};

export type ValidationResult = {
  ok: boolean;
  errors: FileError[];
};
